import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { PageHead, Pill, In, Sel } from "@/components/admin/kit";
import { Loading, Empty } from "@/components/site/Primitives";

export const ENQUIRY_STATUSES = ["New", "Reviewing", "Awaiting Information", "Quote Sent", "Awaiting Payment", "Approved", "Declined", "Converted to Project"];

export default function Enquiries() {
  const [params, setParams] = useSearchParams();
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  const [services, setServices] = useState([]);
  const [q, setQ] = useState(params.get("q") || "");
  const f = { status: params.get("status") || "", service: params.get("service") || "", date_from: params.get("date_from") || "", date_to: params.get("date_to") || "" };
  const key = params.toString();

  useEffect(() => {
    api.get("/admin/services").then((r) => setServices(r.data.map((s) => s.name)));
  }, []);
  useEffect(() => {
    setItems(null);
    api.get("/admin/enquiries", { params: Object.fromEntries(new URLSearchParams(key)) }).then((r) => setItems(r.data));
  }, [key]);

  const upd = (k, v) => { const p = new URLSearchParams(params); v ? p.set(k, v) : p.delete(k); setParams(p); };
  return (
    <div data-testid="admin-enquiries">
      <PageHead eyebrow="Operations" title="Enquiries" />
      <div className="grid md:grid-cols-6 gap-3 mb-6">
        <form className="md:col-span-2" onSubmit={(e) => { e.preventDefault(); upd("q", q); }}>
          <In value={q} onChange={setQ} placeholder="Search name, email, company, ref" testid="enquiries-search" />
        </form>
        <Sel value={f.status} onChange={(v) => upd("status", v)} options={ENQUIRY_STATUSES} placeholder="All statuses" testid="enquiries-filter-status" />
        <Sel value={f.service} onChange={(v) => upd("service", v)} options={services} placeholder="All services" testid="enquiries-filter-service" />
        <input type="date" className="eb-input !py-2.5" value={f.date_from} onChange={(e) => upd("date_from", e.target.value)} aria-label="From date" data-testid="enquiries-filter-from" />
        <input type="date" className="eb-input !py-2.5" value={f.date_to} onChange={(e) => upd("date_to", e.target.value)} aria-label="To date" data-testid="enquiries-filter-to" />
      </div>
      {!items ? <Loading rows={1} /> : items.length === 0 ? <Empty title="No enquiries match." body="Adjust the filters or wait for new submissions." /> : (
        <div className="overflow-x-auto border border-[#27272A]">
          <table className="w-full text-sm" data-testid="enquiries-table">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-zinc-500 border-b border-[#27272A]">
              {["Reference", "Client", "Service", "Videos", "Owner", "Received", "Status"].map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}
            </tr></thead>
            <tbody>
              {items.map((e) => (
                <tr key={e.id} onClick={() => nav(`/admin/enquiries/${e.id}`)} className="border-b border-[#27272A] last:border-0 hover:bg-[#121212] cursor-pointer" data-testid={`enquiry-row-${e.reference}`}>
                  <td className="px-4 py-3 font-mono text-[#00E5FF] whitespace-nowrap">{e.reference}</td>
                  <td className="px-4 py-3"><p>{e.name}</p><p className="text-xs text-zinc-500">{e.company || e.email}</p></td>
                  <td className="px-4 py-3 whitespace-nowrap">{e.service_name}</td>
                  <td className="px-4 py-3">{e.video_count}</td>
                  <td className="px-4 py-3 text-zinc-400">{e.owner_name || "—"}</td>
                  <td className="px-4 py-3 text-zinc-400 whitespace-nowrap">{fmtDateTime(e.created_at)}</td>
                  <td className="px-4 py-3"><Pill status={e.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
